<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <navbar></navbar>
    </div>
    <div class="content page-title">
      <h2>分享管理</h2>
      <div>
        <el-form
            :inline="true"
            id="searchForm"
            :model="searchForm"
            ref="searchForm"
            class="search-form"
        >
          <el-form-item label="平台" prop="platformId">
            <el-select
                v-model="searchForm.platformId"
                placeholder="请选择平台"
                size="small"
                filterable
                clearable
            >
              <el-option
                  v-for="item in platformList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
                type="primary"
                plain
                size="small"
                @click="fetchData('search')"
                @keyup.enter="fetchData('search')"
            >查询
            </el-button>
            <el-button
                type="primary"
                size="small"
                plain
                @click="fetchData('reset')"
            >重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content table">
      <h4>
        <label>{{ share.title }}</label>
      </h4>
      <div class="opt-button">
        <el-button type="primary" plain @click="onDelete('batch')" class="template-del">批量删除</el-button>
        <el-button type="primary" plain @click="onDetails('add')" class="template-add">新增</el-button>
      </div>
      <share-table v-loading="share.loading" :list="share.page.list" :config="share.config"
                   @onOperation="actionOperation" @selectionRow="handleSelection"></share-table>

      <el-pagination
          @size-change="currentChange"
          @current-change="currentChange"
          :current-page="share.page.pageNo"
          :page-size="share.page.pageSize"
          layout="total, prev, pager, next"
          :total="share.page.totalNum">
      </el-pagination>
    </div>

    <!--========================== el-dialog =================================-->
    <el-dialog
        :title="dialog.title"
        :visible.sync="dialog.visible"
        :width="dialog.width"
        :append-to-body="true"
        :custom-class="dialog.type === 'modifyState'? 'modify-state' : ''"
    >
      <template>
        <preview :previewObj="preview"></preview>
      </template>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitDialog">返回</el-button>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import {reactive} from '@vue/composition-api'
import common from './mixins/common.js'
import navbar from '@/components/navbar.vue'
import ShareTable from './components/ShareTable.vue'
import preview from './components/preview.vue'
import Label from '@/pages/examination/label.vue'

export default {
  mixins: [common],
  components: {Label, navbar, ShareTable, preview},
  watch: {
    $route: {
      handler(val, oldVal) {
        // console.log(val)
        this.fetchData()
      },
      immediate: true
      // deep: true
    },
  },
  data() {
    return {
      platformList: [],
      searchForm:{
        platformId: '',
      },
      share: {
        loading: false,
        title: '分享路径列表',
        type: 'share',
        config: [
          {type: 'selection', width: 60},
          {type: 'index', label: '序号', width: 60},
          {prop: 'pathLabel', label: '路径', align: 'left', width: 100},
          {prop: 'platformName', label: '平台', align: 'left', width: 100},
          {prop: 'platformLabel', label: '终端', align: 'left', width: 100},
          {prop: 'imageArr', label: '图片', align: 'center', width: 100, slot: 'image'},
          {prop: 'title', label: '标题', align: 'center', width: 100},
          {prop: 'content', label: '内容', align: 'center', width: 100},
          {prop: 'updatedTime', label: '上次修改时间', align: 'center', width: 100},
          {prop: 'createdTime', label: '创建时间', width: 100},
          {prop: 'operation', slot: 'operation', label: '操作', width: 100}
        ],
        page: {pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, list: [], status: ''}
      },
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      rules: {
        region: [
          {required: true, message: '请选择活动区域', trigger: 'change'}
        ]
      },
      selectionIds: []
    }
  },
  mounted() {

  },
  created() {
    // console.log(this.$route.query.t)
    this.getPlatformList()
    this.fetchData()
  },
  methods: {
    fetchData(type) {
      this.share.loading = true
      if (type == 'reset') {
        this.$refs['searchForm'].resetFields()
        this.share.page.pageNo = 1
        this.share.page.pageSize = 10
      }
      let params = {
        platformId: this.searchForm.platformId,
        pageNo: this.share.page.pageNo,
        pageSize: this.share.page.pageSize,
        status: this.share.page.status
      }
      const searchForm = this.searchForm
      params = Object.assign(params, searchForm)
      // params.categoryId = searchForm.categoryId[searchForm.categoryId.length - 1]
      // 去除字符串 前后 空格
      for (const item in params) {
        if (typeof params[item] === 'string') {
          params[item] = params[item].trim()
        }
      }
      this.$api.shareList(params).then((res) => {
        if (res.code === 0) {
          res.data.list.forEach(e => {
            e['imageArr'] = []
            e.imageArr.push(e.img)
          })
          this.share.page.list = res.data.list
          this.share.page.totalNum = res.data.totalNum
        } else {
          console.log('goodsPageList - 失败', type)
        }
        this.share.loading = false
      }).catch((err) => {
        this.loading = false
        console.log(err)
      })
    },
    // 获取平台列表
    getPlatformList() {
      const params = {}
      this.$api.platformDataList(params).then((res) => {
        this.platformList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // ****************** 翻页 ******************
    currentChange(currentChange) {
      console.log(currentChange)
      this.share.page.pageNo = currentChange
      this.fetchData()
    },
    sizeChange(sizeChange) {
      console.log(sizeChange)
      this.share.page.pageNo = 1
      this.share.page.currentPage = 1
      this.share.page.pageSize = sizeChange
      this.fetchData()
    },
    // ****************** 翻页 end ******************
    actionOperation(obj) {
      const {type, row} = obj
      switch (type) {
        case 'preview':
          // console.log('actionOperation 预览', row)
          this.preview = {
            title: row.title, image: row.img, content: row.content,
            logo: 'http://app.jiuhangyunxuan.com/static/img/loginLogo.37e7e255.png',
            platform: row.platform, inviter: 'xxx', grade: '黄金'
          }
          this.showDialog(row)
          break
        case 'edit':
          console.log('actionOperation 编辑', row)
          this.onDetails(type, row.id)
          break
        default: // delete
          this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.onDelete(row.id)
            console.log('删除', type)
          }).catch((err) => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      }
    },
    handleSelection(valArr) {
      this.selectionIds = valArr
      console.log('handleSelection', valArr)
    },
    centerDialog() {
      this.dialog.visible = false
      this.$message('已取消')
    },

    onDelete(type) {
      const selectionIds = this.selectionIds
      const tempArr = []
      if (type === 'batch') {
        if (selectionIds.length < 1) {
          this.$message('未选')
          return console.log('未选')
        }
        selectionIds.forEach(e => {
          tempArr.push(e)
        })
        console.log('selectionIds', selectionIds)
        console.log('tempArr', tempArr)
      } else {
        tempArr.push(type)
      }
      const params = {ids: tempArr}
      console.log('params', params)
      this.$api.shareDelete(params).then((res) => {
        if (res.code === 0) {
          this.fetchData()
          // console.log('shareDelete - 成功', res)
        } else {
          console.log('shareDelete - 失败', res)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    onDetails(type, id) {
      const t = new Date().getTime()
      if (type === 'edit') {
        this.$router.push({path: '/share/details', query: {type, id, t}})
      } else {
        this.$router.push({path: '/share/details', query: {type, t}})
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import "./manage.scss";
</style>
